@if (giveawayData() && giveawayData()?.state !== 'idle') {
  <div class="entries-layout">
    <div class="entries-frame">
      <video
        #entriesFrameVideo
        class="entries-frame-video"
        [autoplay]="true"
        [muted]="true"
        [loop]="true"
        [playsInline]="true"
        preload="auto"
      >
        <source src="assets/videos/coinwise-entries-border.webm" type="video/webm">
      </video>
    </div>

    <div class="header-area">
      <div class="header">
        <span class="header-text">{{ getHeader() }}</span>
      </div>
    </div>

    <div class="list-area">
      <div class="prize-info">
        <span class="prize-label">PRIZE:</span>
        <span class="prize-value">{{ getPrizeText() }}</span>
      </div>

      <!-- viewport = clip window; track = transformed element. The list is
           rendered a second time (dupSeq) ONLY when it overflows, so a short
           list (e.g. 3 winners) is not duplicated on screen. -->
      <div class="user-list" #viewport>
        <div class="user-track" #track>
          <div #primarySeq>
            @for (user of users(); track trackByUserId($index, user)) {
              <div class="user-item" @appearAnimation>
                <ng-container *ngTemplateOutlet="userRow; context: { $implicit: user }"></ng-container>
              </div>
            }
          </div>
          @if (loop()) {
            <div #dupSeq aria-hidden="true">
              @for (user of users(); track 'dup-' + (user.id ?? $index)) {
                <div class="user-item">
                  <ng-container *ngTemplateOutlet="userRow; context: { $implicit: user }"></ng-container>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <ng-template #userRow let-user>
    @if (user.is_twitch && user.is_youtube) {
      <mat-icon [svgIcon]="'youtube'"></mat-icon>
      <mat-icon [svgIcon]="'twitch'"></mat-icon>
    } @else {
      <mat-icon [svgIcon]="getUserIcon(user)"></mat-icon>
    }
    {{ user.username }}
  </ng-template>
}
